import { render } from "./TanaoroshiSkuListPage.vue?vue&type=template&id=d32bce68"
import script from "./TanaoroshiSkuListPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiSkuListPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src999357143/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__